var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",on:{"click":_vm.onDismiss}},[_c('div',{staticClass:"modal-inner",on:{"click":(e) => e.stopPropagation()}},[(_vm.closeButton)?_c('div',{staticClass:"modal-close",on:{"click":_vm.onDismiss}},[_c('img',{attrs:{"src":_vm.xIcon}})]):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }